<script setup>
const props = defineProps({
  text: Object,
  video: String,
});
</script>

<template> 
  <section class="l-container p-section">
    <div
      class="flex flex-wrap md:pt-[60px]"
      :class="
        text?.position === 'left'
          ? 'flex-col-reverse md:flex-row-reverse'
          : 'flex-col md:flex-row'
      "
    >
      <div class="mb-lg md:mb-0 w-full md:w-1/2 aspect-square overflow-hidden"
      :class="
      text?.position === 'left'
      ? 'mt-lg md:mt-0'
          : 'mb-lg md:mb-0'
      ">
        <video v-if="video" autoplay loop muted playsinline class="w-full h-full object-cover">
          <source :src="video" type="video/mp4" />
        </video>
      </div>
      <div
        class="relative w-full md:w-1/2 md:top-[-60px] flex flex-wrap items-start"
        :class="
          text?.position === 'left' ? 'md:right-[-60px]' : 'md:right-[60px]'
        "
      >
        <div v-if="text?.content" class="w-full p-block" :class="text?.bg">
          <div
            v-html="text?.content"
            class="prose"
            :class="text?.bg === 'bg-white' ? 'prose--black' : ''"
          ></div>
        </div>
      </div>
    </div>
  </section>
</template>

<style></style>
